/** @format */

import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'src/store';
import { Link } from 'react-router-dom';
import { getFooterLinksInfo } from 'src/slices/global';

export const Footer = () => {
  const { footerLinks } = useSelector(state => state.global);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!footerLinks) {
      dispatch(getFooterLinksInfo());
    }
  }, [footerLinks, dispatch]);

  const getRedirectURL = item => {
    if (item?.nid) {
      if (item.public) {
        return `/page/public/${item?.nid}`;
      }
      return `/page/${item?.nid}`;
    }
    return '/404';
  };

  const currentYear = new Date().getFullYear();

  return (
    <>
      <footer>
        <div className="container">
          <div className="footer-inner">
            <span className="footer-copyright">
              © AUMOVIO Aftermarket GmbH <span>{currentYear || '2023'}</span>
            </span>
            <ul className="footer-link">
              {footerLinks &&
                footerLinks.map((item, index) => {
                  return (
                    <li key={index}>
                      <Link to={getRedirectURL(item)}>{item.title}</Link>
                    </li>
                  );
                })}
            </ul>
          </div>
        </div>
      </footer>
    </>
  );
};
